<template>
	<div>
		<div class="new-l">
			<div class="new-title show-one-lines" v-text="param.title"></div>
			<div class="new-banner swiper-container">
				<div class="swiper-wrapper clearfloat" style="transform:translate3d(0px, 0px, 0px)">
					<div class="swiper-slide new-bannerlist" v-for="(item,index) in param.list[0].goods_list" :key="index">
						<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank">
							<div class="item-img">
								<img :src="item.pic_url" alt />
							</div>
							<div class="item-name" v-text="item.name"></div>
							<div class="item-pic" v-text="'¥'+item.price"></div>
						</router-link>
					</div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination new-p"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	import "./index.css";
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			},
		},
		data() {
			return {
				
			};
		},
		mounted() {
			new Swiper(".new-banner", {
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				loop: false, // 循环模式选项
				slidesPerView: 2,
				slidesPerColumn: 2,
				slidesPerGroup: 2,
				speed: 800,
				spaceBetween: 32,
				pagination: {
					el: ".new-p",
					clickable: true,
				},
				observer: true,
				observeParents: true
			});
		}
	};
</script>

<style lang="scss" scoped>
	.new-banner {
		height: 361px;
		padding: 0 16px;
		box-sizing: border-box;

		.new-bannerlist {
			width: 143px;
			float: left;
			height: 155px !important;
			margin-top: 0 !important;

			.hot-img {
				display: block;
			}

			.item-img {
				height: 90px;
				width: 90px;
				margin: 0 auto;
			}

			.item-name {
				width: 143px;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				margin-top: 12px;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;
			}

			.item-pic {
				text-align: center;
				font-size: 16px;
				color: #ff0e25;
				margin-top: 6px;
			}

			&:hover .item-name {
				color: #ff0e25;
			}
		}
	}

	.new-l {
		width: 390px;
		height: 417px;
		margin-top: 20px;
		background-color: #fff;
		padding: 0 20px;
		box-sizing: border-box;

		.new-title {
			line-height: 56px;
			height: 56px;
			font-size: 18px;
			font-weight: 600;
		}

		.new-list {
			width: 350px;

			.new-item {
				margin: 0 16px;
				margin-bottom: 18px;

				&:hover {
					opacity: 0.8;
				}

				&:hover .item-name {
					color: #ff0e25;
					opacity: 0.8;
				}
			}
		}
	}
</style>
